import { useIds as T } from "@chakra-ui/hooks";
import { mergeRefs as g } from "@chakra-ui/react-utils";
import { callAllHandlers as k } from "@chakra-ui/utils";
import { useRef as p, useState as o, useCallback as v } from "react";
function B({ id: c }) {
  const [l, t, i] = T(
    c,
    "odi-odi-card",
    "odi-odi-card--title",
    "odi-odi-card--description"
  ), a = p(null), [u, f] = o(!1), [d, M] = o(!1), [n, m] = o(!1), [C, b] = o(!1), D = v(
    (e = {}, I = null) => {
      var r;
      return {
        ...e,
        ref: g(I, a),
        id: l,
        tabIndex: -1,
        "aria-labelledby": d ? t : void 0,
        "aria-describedby": n ? i : void 0,
        onClick: k(
          e.onClick,
          (s) => s.stopPropagation()
        ),
        /**
           Prevent card from receiving focus
           @see https://stackoverflow.com/a/71244654
           */
        onMouseDown: (r = e == null ? void 0 : e.onMouseDown) != null ? r : (s) => s.preventDefault()
      };
    },
    [i, n, l, t, d]
  );
  return {
    titleId: t,
    descriptionId: i,
    isTopMounted: u,
    setTopMounted: f,
    isTitleMounted: d,
    setTitleMounted: M,
    isDescriptionMounted: n,
    setDescriptionMounted: m,
    isCloseButtonMounted: C,
    setCloseButtonMounted: b,
    cardRef: a,
    getCardProps: D
  };
}
export {
  B as useOdiCard
};
